<template>
    <div class="card border-white clinician-employees" id="Clinician__Patients">
        <header class="d-flex align-items-center py-2 px-3 bg-primary text-white font-size-md fw-bold">
            <span> Employee </span>
            <i class="ms-auto fas fa-times" @click="closeEmployees()"></i>
        </header>
        <form @submit.prevent="submitForm">
            <div class="d-flex p-2">
                <input
                    type="text"
                    autofocus
                    class="form-control"
                    v-model="searchQuery"
                    placeholder="Search by Employee Name"
                />
                <div class="input-group-append ms-2">
                    <button type="submit" :disabled="disableForm()" class="btn btn-primary">Search</button>
                </div>
            </div>
        </form>
        <section
            class="d-flex flex-column overflow-auto flex-nowrap w-100 h-100 scroll-paginate"
            :class="`${userOs == 'Windows' ? 'custom-scrollbar' : ''}`"
        >
            <template v-if="employeeList.length && !hasError">
                <div class="patient employee-card" v-for="employee of employeeList">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                        <span class="d-flex align-items-center font-size-md">
                            <b>{{ employee.lastName }}, {{ employee.firstName }}</b>
                        </span>
                        <span>
                            <a @click="handleNavigation(employee)" class="align-self-start" href="javascript:void(0);">
                                View Chart
                            </a>
                        </span>
                    </div>
                    <div class="d-flex justify-content-between mb-1">
                        <ProductPill
                            class="application-name"
                            :product-id="getApplicationId(employee.application)"
                        ></ProductPill>
                        <p
                            v-if="employee.status"
                            :class="'fw-bold mb-0 status-label ' + getStatusText(employee.status).toLowerCase()"
                        >
                            Status : <span> {{ getStatusText(employee.status) }} </span>
                        </p>
                    </div>
                    <div class="text-default">{{ employee.organization }}</div>
                    <div v-if="employee.address" class="mt-1 mb-1">
                        <span v-if="employee.address.addressLine1"> {{ employee.address.addressLine1 }} </span>
                        <span v-if="employee.address.addressLine2">, {{ employee.address.addressLine2 }} </span>
                        <span v-if="employee.address.city">, {{ employee.address.city }} </span>
                        <span v-if="employee.address.state">, {{ employee.address.state }} </span>
                        <span v-if="employee.address.zipCode">, {{ employee.address.zipCode }} </span>
                    </div>
                    <div class="d-flex">
                        <span v-if="employee.phone" class="d-flex align-items-center me-4">
                            <i class="fas fa-mobile text-primary me-1"></i>
                            <a :href="'tel:' + employee.phone"> {{ formatPhone(employee.phone) }} </a>
                        </span>
                        <span v-if="employee.birthday" class="d-flex align-items-center">
                            <i class="fas fa-birthday-cake text-primary me-1"></i>
                            <span> {{ formatDate(employee.birthday, "MMM DD, YYYY") }} </span>
                        </span>
                    </div>
                </div>
            </template>
            <!-- WAITING -->
            <p
                v-if="isLoading == null && !hasError"
                class="d-flex flex-column w-100 align-items-center text-center py-5 px-3 text-primary"
            >
                <i class="fas fa-search fa-5x mb-4"></i>
            </p>
            <p
                v-if="isLoading && !hasError"
                class="d-flex flex-column w-100 align-items-center text-center py-5 px-3 text-primary"
            >
                <i class="fas fa-search fa-5x mb-4"></i>
                <span class="font-size-lg"> Searching.... </span>
            </p>
            <!-- ERROR -->
            <div v-if="hasError && !isLoading" class="error-state">
                <p>There was a problem while fetching employees.<br />Please try again.</p>
                <button :disabled="disableForm()" class="btn btn-primary" @click="searchEmployee()">Try Again</button>
            </div>
            <!-- NO DATA -->
            <p class="no-data" v-if="employeeList.length === 0 && isLoading == false && !hasError">
                <i>No employees found.</i>
            </p>
        </section>
    </div>
</template>

<script lang="ts" src="./EmployeeList.ts"></script>
<style lang="scss" src="../PatientList/PatientList.scss"></style>
